export default "__VITE_ASSET__D8or3IVL__"